import { useState } from 'react'
import type { Ton } from '../../components/ui/TonuriB4L'

/* Bucati comune ale paginii Taxe & impozite: TVA (faza 1) si impozitul pe profit (faza 2). */

export interface DocLista {
  data: string | null
  document: string
  partener: string
  cont?: string
  suma: number
  detaliu?: string
}

export const lei = (n: number) =>
  n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
export const zi = (iso: string | null) =>
  iso ? iso.slice(0, 10).split('-').reverse().join('.') : '—'

export function mesajEroare(err: unknown): string {
  return (
    (err as { response?: { data?: { error?: { message?: string } } } })?.response?.data?.error
      ?.message ?? 'A apărut o eroare. Încearcă din nou.'
  )
}

/** „1.234,56" sau „1234.56" → numar; gol → null. */
export function citesteSuma(s: string): number | null {
  const t = s.trim().replace(/\s/g, '')
  if (!t) return null
  const n = Number(t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t)
  return Number.isFinite(n) ? n : NaN
}

export type StareObligatie = 'estimat' | 'declarat' | 'platit'
export const STARE: Record<StareObligatie, { eticheta: string; ton: Ton }> = {
  estimat: { eticheta: 'estimat', ton: 'albastru' },
  declarat: { eticheta: 'declarat', ton: 'galben' },
  platit: { eticheta: 'plătit', ton: 'verde' },
}

export function ListaDocumente({ docs }: { docs: DocLista[] }) {
  const [toate, setToate] = useState(false)
  const arata = toate ? docs : docs.slice(0, 50)
  return (
    <>
      <table className="w-full border-collapse text-mic">
        <thead>
          <tr className="text-left text-b4l-text-muted">
            <th className="py-1 pr-2 font-medium">Data</th>
            <th className="py-1 pr-2 font-medium">Document</th>
            <th className="py-1 pr-2 font-medium">Partener</th>
            <th className="py-1 pr-2 font-medium">Cont</th>
            <th className="py-1 pr-2 font-medium">Detaliu</th>
            <th className="py-1 text-right font-medium">Suma</th>
          </tr>
        </thead>
        <tbody>
          {arata.map((x, i) => (
            <tr key={i} className="align-top">
              <td className="py-1 pr-2 tabular-nums">{zi(x.data)}</td>
              <td className="py-1 pr-2">{x.document}</td>
              <td className="py-1 pr-2">{x.partener || '—'}</td>
              <td className="py-1 pr-2">{x.cont ?? '—'}</td>
              <td className="py-1 pr-2 text-b4l-text-muted">{x.detaliu ?? ''}</td>
              <td className="py-1 text-right tabular-nums">{lei(x.suma)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {docs.length > 50 && !toate && (
        <button
          type="button"
          onClick={() => setToate(true)}
          className="mt-1 text-mic text-b4l-blue hover:underline"
        >
          Arată toate cele {docs.length}
        </button>
      )}
    </>
  )
}
